import {
  publishAddCopilotChatReference,
  publishOpenCopilotChat,
  publishPreloadCopilotChat,
} from '@github-ui/copilot-chat/utils/copilot-chat-events'
import {CopilotChatIntents, type FileDiffReference} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {copilotChatPanelID, copilotDockedPanelID} from '@github-ui/copilot-chat/utils/constants'
import {sendEvent} from '@github-ui/hydro-analytics'
import {CopilotIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useCallback} from 'react'

export interface CopilotDiffExplainButtonProps {
  fileDiffReference: FileDiffReference
}

export function CopilotDiffExplainButton({fileDiffReference}: CopilotDiffExplainButtonProps) {
  const handleClick = useCallback(() => {
    const chatPanelIsOpen =
      !!document.getElementById(copilotChatPanelID) || !!document.getElementById(copilotDockedPanelID)
    if (chatPanelIsOpen) {
      sendEvent('copilot.file-diff.attach', {target: 'file-diff-header', mode: 'assistive', action: 'add_reference'})
      publishAddCopilotChatReference(fileDiffReference)
    } else {
      sendEvent('copilot.file-diff.attach', {target: 'file-diff-header', mode: 'assistive', action: 'new_thread'})
      publishOpenCopilotChat({
        intent: CopilotChatIntents.conversation,
        references: [fileDiffReference],
        newThread: true,
        skipImplicitReferences: true,
        id: 'file-diff-header',
      })
    }
  }, [fileDiffReference])

  const handlePreload = () => {
    publishPreloadCopilotChat()
  }

  return (
    <IconButton
      icon={CopilotIcon}
      size="small"
      aria-label="Ask about this diff"
      onClick={handleClick}
      onMouseEnter={handlePreload}
      onFocus={handlePreload}
      data-testid="copilot-diff-explain-button"
    />
  )
}
